import type { IconType } from 'react-icons';
import {
    PiAirplaneTiltDuotone,
    PiArrowsCounterClockwiseDuotone,
    PiCalendarDotsDuotone,
    PiChartBarDuotone,
    PiChartLineUpDuotone,
    PiChartPieSliceDuotone,
    PiChecksDuotone,
    PiClipboardTextDuotone,
    PiCurrencyDollarDuotone,
    PiGearDuotone,
    PiHandshakeDuotone,
    PiMagnifyingGlassDuotone,
    PiMedalDuotone,
    PiPackageDuotone,
    PiShieldCheckDuotone,
    PiHandCoinsDuotone,
    PiWarningOctagonDuotone,
    PiSealWarningDuotone,
    PiSealCheckDuotone,
    PiShieldWarningDuotone,
    PiSlidersDuotone,
    PiSquaresFourDuotone,
    PiTargetDuotone,
    PiTreeStructureDuotone,
    PiTruckDuotone,
    PiUsersDuotone,
    PiWarehouseDuotone,
} from 'react-icons/pi';

const NAV_ICON_MAP: Record<string, IconType> = {
    '/': PiSquaresFourDuotone,
    '/dashboard/executive': PiChartBarDuotone,
    '/dashboard/finance': PiCurrencyDollarDuotone,
    '/finance/tv': PiChartLineUpDuotone,
    '/comex': PiAirplaneTiltDuotone,
    '/estoque': PiWarehouseDuotone,
    '/estoque/aprovacoes': PiChecksDuotone,
    '/estoque/config-reservas': PiSlidersDuotone,
    '/estoque/consulta': PiMagnifyingGlassDuotone,
    '/shipments': PiTruckDuotone,
    '/products': PiPackageDuotone,
    '/clients': PiUsersDuotone,
    '/orders': PiChartBarDuotone,
    '/ploomes-deals': PiHandshakeDuotone,
    '/users': PiUsersDuotone,
    '/roles-permissions': PiShieldCheckDuotone,
    '/rma': PiPackageDuotone,
    '/equipment-configurator': PiGearDuotone,
    // Comissionamento
    '/commissioning': PiChartLineUpDuotone,
    '/commissioning/sales-calendar': PiCalendarDotsDuotone,
    '/commissioning/org-chart': PiChartBarDuotone,
    '/commissioning/buckler-one': PiMedalDuotone,
    '/commissioning/gluteleader': PiChartPieSliceDuotone,
    '/commissioning/records': PiClipboardTextDuotone,
    '/commissioning/payment-approvals': PiCurrencyDollarDuotone,
    '/commissioning/teams': PiUsersDuotone,
    '/commissioning/structures': PiTreeStructureDuotone,
    '/commissioning/payment-rules': PiCurrencyDollarDuotone,
    '/commissioning/modifiers': PiSlidersDuotone,
    '/commissioning/goals': PiTargetDuotone,
    '/commissioning/cashflow': PiCalendarDotsDuotone,
    '/commissioning/audit': PiArrowsCounterClockwiseDuotone,
    '/commissioning/exception-audits': PiShieldWarningDuotone,
    '/commissioning/approvers': PiSealCheckDuotone,
    '/my-gluteleader': PiHandCoinsDuotone,
    '/defaulted-installments': PiWarningOctagonDuotone,
    '/sales-exceptions': PiSealWarningDuotone,
    '/commissioning/ploomes-field-inspector': PiMagnifyingGlassDuotone,
};

export function getNavIcon(href: string): IconType {
    const normalized = href === '/' ? '/' : href.replace(/\/$/, '');
    if (NAV_ICON_MAP[normalized]) {
        return NAV_ICON_MAP[normalized];
    }
    if (normalized.startsWith('/settings')) {
        return PiGearDuotone;
    }

    return PiSquaresFourDuotone;
}
